import { useQuery } from "@tanstack/react-query"
import { ErrorResponse, SuccessResponse, useHttpClient } from "api/api"
import { Team } from "interface/user"

const queryKeys = {
	teams: "teams",
}

export const useAdminTeams = () => {
	const { httpClient } = useHttpClient()

	return useQuery<Team[], ErrorResponse>({
		queryKey: [queryKeys.teams],
		async queryFn({ signal }) {
			const {
				data: { data },
			} = await httpClient.get<SuccessResponse<Team[]>>(
				"/api/v1/admin/field-support-teams",
				{
					signal,
				},
			)
			return data
		},
	})
}
